import { render } from "./UpcomingAnniversaries.vue?vue&type=template&id=6242e5b6&scoped=true"
import script from "./UpcomingAnniversaries.vue?vue&type=script&lang=js"
export * from "./UpcomingAnniversaries.vue?vue&type=script&lang=js"

import "./upcoming-anniversaries.scss?vue&type=style&index=0&id=6242e5b6&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6242e5b6"]])

export default __exports__